// strip redundant data without changing the structure of the data
export var stripRedundantData = function stripRedundantData(rawNavData) {
  return {
    l1_navigation: rawNavData.l1_navigation.map(function (l1) {
      return {
        l1_navigation_link: l1.l1_navigation_link.map(function (link) {
          return {
            title: link.title,
            url: link.url
          };
        }),
        l1_display_text: l1.l1_display_text,
        underline_color: l1.underline_color,
        title_colour: l1.title_color,
        l2_navigation: l1.l2_navigation.map(function (l2) {
          return {
            l2_navigation_link: l2.l2_navigation_link.map(function (link) {
              return {
                title: link.title,
                url: link.url
              };
            }),
            l2_display_text: l2.l2_display_text,
            l3_navigation: l2.l3_navigation.map(function (l3) {
              return {
                l3_navigation_link: l3.l3_navigation_link.map(function (link) {
                  return {
                    title: link.title,
                    url: link.url
                  };
                }),
                l3_display_text: l3.l3_display_text
              };
            })
          };
        })
      };
    })
  };
};